/* Host injection seam for the enterprise-local GtcAgent bundle.
 *
 * doc-agent 의 ``docAgentSlot`` 과 같은 패턴이다. GTC 페이지는 enterprise 앱에
 * 있고 (PDF 렌더·업로드 등 host 의존), 공통 라우팅은 tenant-neutral 이어야
 * 하므로 host 가 bootstrap 시점에 컴포넌트를 주입한다.
 */

import type React from 'react';

export type GtcAgentModePageComponent = React.ComponentType;

let modePage: GtcAgentModePageComponent | null = null;

export function setGtcAgentModePageComponent(
  component: GtcAgentModePageComponent | null,
): void {
  modePage = component;
}

export function getGtcAgentModePageComponent(): GtcAgentModePageComponent | null {
  return modePage;
}

export interface GtcAgentPanelProps {
  pageSidebarOpen: boolean;
  onTogglePageSidebar: () => void;
}

let panel: React.ComponentType<GtcAgentPanelProps> | null = null;

export function setGtcAgentPanelComponent(component: React.ComponentType<GtcAgentPanelProps> | null): void {
  panel = component;
}

export function getGtcAgentPanelComponent(): React.ComponentType<GtcAgentPanelProps> | null {
  return panel;
}

/**
 * 콘텐츠 위 공용 헤더 줄(`WorkspaceHeader` 자리)을 GTC 가 직접 그린다.
 *
 * 비교 결과 화면은 그 줄에 "기준판 ⇄ 개정판" 문서 이름과 내보내기를 앉힌다
 * (문서 에이전트 편집 화면과 같은 틀). 결과가 없는 화면(런처·문서 QA)에서는
 * 주입된 컴포넌트가 공용 헤더로 되돌아가야 한다 — 그 판단은 host 가 한다.
 * 레이아웃은 접힌 목록 펼치기 단추를 그대로 띄우므로, 헤더는 그 자리(왼쪽 48px)를
 * 비워 두어야 한다.
 */
export interface GtcAgentHeaderProps {
  pageSidebarOpen: boolean;
}

let header: React.ComponentType<GtcAgentHeaderProps> | null = null;

export function setGtcAgentHeaderComponent(component: React.ComponentType<GtcAgentHeaderProps> | null): void {
  header = component;
}

export function getGtcAgentHeaderComponent(): React.ComponentType<GtcAgentHeaderProps> | null {
  return header;
}
